import { pdfsLegacyShape } from '@/api2/clinicalBridge';
import { defineChartDocumentList } from '@/stores/chartDocumentList';

/**
 * The open chart's uploaded PDFs, for the screens that read them out of
 * `getAllData` — the Clinical PDFs page (`store/modules/pdf.js`, `allData.pdfs`)
 * and `PdfContentBody.vue`. pacmny-be shipped them in that blob; the port's
 * `getAllData` is `/me/bootstrap`, which knows nothing about a chart, so they are
 * read from `GET /pdf-documents?filter[patient_id]=` and laid over it by the
 * `login/getAllData` getter. The rows' rules (uid ids, uploads only, newest
 * first, local timestamps) are `pdfsLegacyShape`'s; how and when the list is
 * read is `defineChartDocumentList`'s.
 */
const chartPdfs = defineChartDocumentList('chartPdfs', {
  path: '/pdf-documents',
  shape: pdfsLegacyShape,
  failedKey: 'pdfsLoadFailed',
});

export const useChartPdfsStore = chartPdfs.useStore;

/** `{pdfs, pdfsLoadFailed}` for the chart in view, once read; `{}` until then. */
export const chartPdfsForGetAllData = chartPdfs.forGetAllData;
